<template>
  <div class="page">
    <!-- 广告图 -->
    <div class="banner">
      <div class="banner-content d-flex justify-center">
        <div class="box d-flex f-column align-center">
          <h3>溯源查询</h3>
          <p>通过溯源码查询产品来源信息</p>
          <div class="search d-flex align-center">
            <el-input class="input" v-model="searchVal" placeholder="请输入溯源查询码进行查询"></el-input>
            <el-button type="primary" @click='detailAuth'>查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- <Banner/> -->

    <!-- 溯源信息展示样例 -->
    <Info v-if="!suyuaninfo" />
    <!-- 查询结果 -->
    <div class="list" v-if="suyuaninfo">
      <h3 style="font-size: 0.375rem;margin-bottom: 0.375rem;text-align: center;">溯源信息展示</h3>
      <p style="text-transform: uppercase;font-size: 0.2rem;color: #666;margin-bottom: 1rem;text-align: center;">　</p>
       <!-- <div style="width: 100%;overflow: hidden;">
          <span class="czzs" @click="lookimg(suyuaninfo.certificateUrl)">存证证书</span>
        </div> -->
      <div class="item" v-if="suyuaninfo.hotchainbusmygl">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_06.png')"></el-image>
          <span class="name">存证证书</span>
        </div>
        <div class="con flex-1">
          <div class="con-item d-flex">
			<el-image
			  style="width: 3.2rem;display: block;cursor: pointer;"
			  :src="'https://trace.hogdata.cn/hogchain-boot/'+suyuaninfo.certificateUrl"
			  :preview-src-list="['https://trace.hogdata.cn/hogchain-boot/'+suyuaninfo.certificateUrl]">
			</el-image>
          </div>
        </div>
      </div>
      <div class="item" v-if="suyuaninfo.hotchainbusmygl">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_01.png')"></el-image>
          <span class="name">养殖环节信息</span>
        </div>
        <div class="con flex-1">
          <div class="con-item d-flex"
            v-for="item,index in suyuaninfo.hotchainbusmygl" v-show="item">
            <p class="desc flex-1">{{index +'：'+item}}</p>
          </div>
        </div>
      </div>
      <div class="item" v-if="suyuaninfo.hotchainbusszcg">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_01.png')"></el-image>
          <span class="name">生猪采购信息</span>
        </div>
        <div class="con flex-1">
          <div class="con-item d-flex"
            v-for="item,index in suyuaninfo.hotchainbusszcg" v-show="item">
            <p class="desc flex-1">{{index +'：'+item}}</p>
          </div>
        </div>
      </div>
      <div class="item" v-if="suyuaninfo.hotchainbuscdjy">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_02.png')"></el-image>
          <span class="name">产地检疫信息</span>
        </div>
        <div class="con flex-1">
          <div class="con-item d-flex"
            v-for="item,index in suyuaninfo.hotchainbuscdjy" v-show="item">
            <p class="desc flex-1">{{index +'：'+item}}</p>
          </div>
          <div class="con-item d-flex">
            <p class="desc flex-1">检疫结果:检疫合格</p>
          </div>
			  <el-image 
			    style="display: block;width: 2.5rem;float: left;margin: 0.15rem 0rem;padding-bottom: 0.2rem;cursor: pointer;"
			    :src="'https://trace.hogdata.cn/hogchain-boot/'+suyuaninfo.cdjyFileUrl"
			    :preview-src-list="['https://trace.hogdata.cn/hogchain-boot/'+suyuaninfo.cdjyFileUrl]">
			  </el-image>
        </div>
      </div>

      <div class="item" v-if="suyuaninfo.hotchainbuscdmy">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_03.png')"></el-image>
          <span class="name">屠宰检疫信息</span>
        </div>
        <div class="con flex-1">

          <div class="con-item d-flex"
            v-for="item,index in suyuaninfo.hotchainbuscdmy" v-show="item">
            <p class="desc flex-1">{{index +'：'+item}}</p>
          </div>
          <div class="con-item d-flex">
            <p class="desc flex-1">检疫结果:检疫合格</p>
          </div>
		    <el-image 
		      style="display: block;width: 2.5rem;float: left;margin: 0.15rem 0rem;padding-bottom: 0.2rem;cursor: pointer;"
		      :src="'https://trace.hogdata.cn/hogchain-boot/'+suyuaninfo.tzjyFileUrl"
		      :preview-src-list="['https://trace.hogdata.cn/hogchain-boot/'+suyuaninfo.tzjyFileUrl]">
		    </el-image>
        </div>
      </div>
      <div class="item" v-if="suyuaninfo.hotchainbusrpjy">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_04.png')"></el-image>
          <span class="name">肉品检疫信息</span>
        </div>
        <div class="con flex-1">

          <div class="con-item d-flex"
            v-for="item,index in suyuaninfo.hotchainbusrpjy" v-show="item">
            <p class="desc flex-1">{{index +'：'+item}}</p>
          </div>
        </div>
      </div>
      <div class="item" v-if="suyuaninfo.hotchainbuspsgl">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_05.png')"></el-image>
          <span class="name">物流运输信息</span>
        </div>
        <div class="con flex-1">
          <div class="con-item d-flex"
            v-for="item,index in suyuaninfo.hotchainbuspsgl" v-show="item">
            <p class="desc flex-1">{{index +'：'+item}}</p>
          </div>
        </div>
      </div>
      <div class="item" v-if="suyuaninfo.hotchainbusxsgl">
        <div class="title d-flex align-center">
          <el-image class="image" :src="require('@/assets/images/icon_06.png')"></el-image>
          <span class="name">销售环节信息</span>
        </div>
        <div class="con flex-1">
          <div class="con-item d-flex"
            v-for="item,index in suyuaninfo.hotchainbusxsgl" v-show="item">
            <p class="desc flex-1">{{index +'：'+item}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <SearchResult/> -->
    <!-- 反馈信息 -->
    <div class="feedback d-flex align-center justify-center" v-if="suyuaninfo">
      <div class="wrap d-flex f-column align-center justify-center">
        <h3>填写以下表格，反馈该溯源信息发现的问题以及意见</h3>
        <p>填写姓名信息等联系方式信息提交至我们</p>
        <div class="form-wrap">
          <el-form :model="feedForm" :rules="rules" ref="feedRef">
            <el-form-item prop="firstname">
              <el-input v-model="feedForm.xing" placeholder="姓"></el-input>
            </el-form-item>
            <el-form-item prop="lastname">
              <el-input v-model="feedForm.ming" placeholder="名"></el-input>
            </el-form-item>
            <el-form-item prop="email">
              <el-input v-model="feedForm.email" placeholder="邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="contact">
              <el-input v-model="feedForm.phone" placeholder="联系方式"></el-input>
            </el-form-item>
            <el-form-item prop="product">
              <el-input v-model="feedForm.chanpin" placeholder="请输入反馈的产品"></el-input>
            </el-form-item>
            <el-form-item prop="opinion">
              <el-input v-model="feedForm.yijian" type="textarea" :maxlength="150" show-word-limit resize="none"
                :autosize="{ minRows: 6 }" placeholder="填写反馈意见，最多输入150个字符"></el-input>
            </el-form-item>
          </el-form>
          <div class="btn" @click="fankui">提交</div>
        </div>
      </div>
    </div>

    <div class="showimg" v-show="imgshow" >
      <p style="font-size: 0.4rem;color: #333333;text-align: center;line-height: 2rem;">查看</p>
      <span @click="closimg">关闭</span>
      <img style="width: 5.5rem;display: block;margin: 0 auto;" :src="'https://trace.hogdata.cn/hogchain-boot/'+imgsrc">
    </div>
  </div>
</template>
<script>
  // import Banner from './components/banner.vue'
  import Info from './components/info.vue'
  // import SearchResult from './components/search-result.vue'
  export default {
    name: 'Search',
    components: {
      // Banner,
      Info,
      // SearchResult
    },
    created() {
      console.log('溯源查询')
    },
    mounted() {
      let val = this.$route.query.sourceCode
      this.searchVal = val
      if (val) {
        this.detailAuth()
      }

    },

    data() {
      return {
        shos: false,
        searchVal: '',
        suyuaninfo: '',
        feedForm: {
          xing: '',
          ming: '',
          email: '',
          phone: '',
          chanpin: '',
          yijian: ''
        },
        rules: {},
        imgshow:false,
        imgsrc:'',
      }
    },
    methods: {
      detailAuth() {
        if (!this.searchVal) {
          alert('请输入溯源查询码进行查询');
          return
        }
		var Register=0
		if(JSON.parse(localStorage.getItem("logininfo"))==null){
			Register=0
		}else{
			Register=1
		}
		console.log(Register)
        // 发ajax请求，用以获取数据，此处地址意思是查询 github中 vue 星数最高的项目
        const url = 'https://trace.hogdata.cn/hogchain-boot//hogchain/hotchainBusChaincode/detailAuth';
        this.$http.post(url, {
          sourceCode: this.searchVal,
			clientType:3,
			isRegister:Register
        }).then(
          response => {
            if (response.body.code == 200) {
              this.shos = true,
                this.suyuaninfo = response.body.result
            } else {
              this.suyuaninfo = ''
              alert(response.body.message);
            }
          },

          response => {
            this.suyuaninfo = ''
            alert(response.body.message);
          },
        );
      },
      closimg(){
        this.imgshow=false
      },
      lookimg(e){
				        this.$alert('这是一段内容', '标题名称', {
				          confirmButtonText: '确定',
				          callback: action => {
				            this.$message({
				              type: 'info',
				              message: `action: ${ action }`
				            });
				          }
				        });
        // console.log('https://trace.hogdata.cn/hogchain-boot/chaincer_1626773777428.jpg'+e)
        // window.location.href=
		// window.open('https://trace.hogdata.cn/hogchain-boot/'+e)
      },
      // 反馈信息
      fankui() {
        if (this.feedForm.xing == '' || this.feedForm.ming == '' || this.feedForm.email == '' || this.feedForm.phone ==
          '' || this.feedForm.chanpin == '' || this.feedForm.yijian == '') {
          alert("输入反馈信息不可为空！")
          return false
        }
        // 发ajax请求，用以获取数据，此处地址意思是查询 github中 vue 星数最高的项目
        const url = 'https://trace.hogdata.cn/hogchain-boot/hogchain/hotchainBusFankui/add';
        this.$http.post(url, this.feedForm).then(
          response => {
            if (response.body.code == 200) {
              alert("反馈成功")
              this.feedForm = {
                xing: '',
                ming: '',
                email: '',
                phone: '',
                chanpin: '',
                yijian: ''
              }
            } else {
              alert(response.body.message);
            }
          },

          response => {
            this.suyuaninfo = ''
            alert(response.body.message);
          },
        );
      }
    },
  }
</script>

<style lang="scss" scoped>
  .banner {
    width: 100%;
    height: 5rem;
    background: url('../../assets/images/search_banner.jpg') no-repeat;
    background-size: 100% 5rem;

    &-content {
      width: 100%;
      height: 100%;

      .box {
        padding-top: 1.025rem;
        color: #fff;

        h3 {
          font-size: 0.375rem;
          margin-bottom: 0.35rem;
        }

        p {
          font-size: 0.2rem;
          opacity: 0.6;
          margin-bottom: 0.375rem;
        }

        .search {
          .input {
            width: 6.875rem;
            font-size: 0.2rem;

            ::v-deep .el-input__inner {
              height: 0.75rem;
              line-height: 0.75rem;
              border: none;
              border-radius: 0;
            }
          }

          ::v-deep .el-button {
            border: none;
            border-radius: 0;
            padding: 0.275rem 0.6125rem;
            font-size: 0.2rem;
          }
        }
      }
    }
  }

  .list {
    width: 15rem;
    padding-top: 1.25rem;
    padding-bottom: 0.875rem;
    margin: 0 auto;

    .item {
      float: left;
      width: 4.8125rem;
      height: 5.625rem;
      overflow: auto;
      padding: 0.25rem 0.35rem;
      margin-right: 0.275rem;
      margin-bottom: 0.375rem;
      background-color: #f9fafe;
      box-shadow: 0.025rem 0.025rem 0.05rem 0 rgba(153, 153, 153, 0.4);

      &:nth-of-type(3n + 3) {
        margin-right: 0;
      }

      .title {
        padding-bottom: 0.225rem;

        .image {
          width: 0.375rem;
          height: 0.375rem;
        }

        .name {
          padding-left: 0.125rem;
          font-weight: 600;
          font-size: 0.225rem;
          color: #666;
        }
      }

      .con {
        &-item {
          line-height: 0.35rem;
          font-size: 0.2rem;
          color: #999;

          .head {
            margin-right: 0.125rem;
            min-width: 0.4rem;
          }

          .desc {
            word-break: break-all;
          }
        }
      }
    }
  }

  .nonlist {
    width: 100%;
  }

  .nonlist img {
    display: block;
    width: 1rem;
    margin: 0 auto;
    margin-top: 1.3rem;
  }

  .nonlist p {
    text-align: center;
    font-size: 12px;
    line-height: 40px;
    color: #666666;
  }

  .item::-webkit-scrollbar {
    width: 4px;
    /*height: 4px;*/
  }

  .item::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .item::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);

  }

  .feedback {
    width: 100%;
    background-color: #f9fafe;

    .wrap {
      h3 {
        font-size: 0.225rem;
        padding: 1.225rem 0 0.375rem;
      }

      p {
        font-size: 0.2rem;
        color: #666;
        margin-bottom: 1rem;
      }

      .form-wrap {
        width: 12.75rem;

        ::v-deep .el-form {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;

          .el-form-item {
            width: 6.25rem;
            margin-bottom: 0.25rem;

            .el-form-item__content {
              line-height: 0.75rem;
              font-size: 0.2rem;

              .el-input {
                font-size: 0.2rem;

                .el-input__inner {
                  border-radius: 0;
                  border: none;
                  height: 0.75rem;
                  line-height: 0.75rem;
                  padding: 0 0.1875rem;
                }
              }

              .el-textarea {
                font-size: 0.2rem;

                .el-textarea__inner {
                  padding: 0.0625rem 0.1875rem;
                  border: none;
                  border-radius: 0;
                }

                .el-input__count {
                  line-height: 0.25rem;
                  background-color: transparent;
                }
              }
            }

            &:nth-of-type(5),
            &:nth-of-type(6) {
              width: 100%;
            }
          }
        }
      }

      .btn {
        width: 1.625rem;
        height: 0.75rem;
        line-height: 0.75rem;
        background-color: #15b5ff;
        text-align: center;
        font-size: 0.2rem;
        color: #fff;
        user-select: none;
        cursor: pointer;
        margin-bottom: 1.25rem;

        &:active {
          opacity: 0.8;
        }
      }
    }
  }

  .showimg{
    display: block;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background-color: #ffffff;
     padding: 30rpx;
     z-index: 999;
  }
  .showimg span{
    display: inline-block;
    position: absolute;
    right: 1rem;
    top:1rem;
    color: #333333;
    font-size: 0.3rem;
    cursor: pointer;
    z-index: 10000;
  }
  .czzs{
    width: 2rem;
    height: 0.5rem;
    background: linear-gradient(0deg, rgba(3, 104, 255, 0.97), rgba(25, 144, 255, 0.97));
    box-shadow: 0px 4px 8px 0px rgba(0, 85, 255, 0.4);
    border-radius: 0.25rem;
    font-size: 0.2rem;
    font-weight: 700;
    color: #ffffff;
    line-height: 0.5rem;
    text-align: center;
    margin-bottom: 0.5rem;
    float: right;
    margin-right: 0.2rem;
    cursor: pointer;
  }
</style>
